import api from '../api';

import { ParamsBodyEffectSchedule } from 'utils/typeServices';

export const PostAgendamentoDesinstalacao = async ({ token, body, NR_PLATAFORMA }: { token: string, body: ParamsBodyEffectSchedule, NR_PLATAFORMA: number }) => {
    const bodyJson = JSON.stringify(body);

    try {
        const data = await api.post(`v1/Agendamento/AgendamentoDesinstalacao?NR_PLATAFORMA=${NR_PLATAFORMA}`, bodyJson, {
            headers: {
                'Authorization': 'Bearer ' + token
            }
        });

        return { data: data };
    } catch (error) {
        console.error('error', error);
        return { data: null };
    }
}
